import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { IconComponent } from '@design-system/buttons/icon/icon.component';
import { BodyMediumComponent } from '@design-system/typography/body-md/body-medium.component';
import { AnchorComponent } from '@design-system/buttons/anchor/anchor.component';
import { NavDrawerRoute } from '../models/nav-actions.model';
import {
  isExpandableNavSection,
  isNavSectionActive,
  isSingleNavLink,
  navTitleToTestId,
} from '../nav-route-tree.util';
import { SubNavComponent } from '../sub-nav/sub-nav.component';
import { TestIdDirective } from '@design-system/core/test-id.directive';

@Component({
  selector: 'app-nav-tree-section',
  templateUrl: './nav-tree-section.component.html',
  styleUrls: ['./nav-tree.styles.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    IconComponent,
    BodyMediumComponent,
    AnchorComponent,
    SubNavComponent,
    NavTreeSectionComponent,
    TestIdDirective,
  ],
})
export class NavTreeSectionComponent {
  @Input({ required: true }) route!: NavDrawerRoute;
  @Input() nested = false;
  @Input() activeTitle = '';
  @Input({ required: true }) expandedTitles!: Set<string>;
  @Output() toggle = new EventEmitter<NavDrawerRoute>();

  readonly isSingleNavLink = isSingleNavLink;
  readonly isExpandableNavSection = isExpandableNavSection;
  readonly isNavSectionActive = isNavSectionActive;

  get testId(): string {
    return `${navTitleToTestId(this.route.title)}-navigation-link`;
  }

  get isExpanded(): boolean {
    return this.expandedTitles.has(this.route.title);
  }
}
